import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { ForensicEvidenceSection } from '../../../components/ToxicDetector/ForensicEvidenceSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageDE() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: KI-Beziehungsanalyse | Toxische Muster & Gaslighting erkennen" description="Finden Sie heraus, ob Ihr Ex das Problem ist. Laden Sie Ihre Chats in die KI von ToxicDetector hoch, um eine sofortige, vertrauliche Analyse von Manipulation, Gaslighting und Warnsignalen zu erhalten. Starten Sie jetzt den kostenlosen Scan." keywords="KI-Beziehungsanalyse, toxische Muster erkennen, Gaslighting-Detektor, toxischer Ex, Manipulationsprüfung, Beziehungstoxizität, KI-Textscanner" canonical="https://toxicdetector.com/de" language="de" alternateUrls={alternateUrls} data-id="element-4474" data-mp="wogzjzb17lta" />
      <GoogleTranslateWidget data-id="element-4475" data-mp="2mtbthofyh1kg" />
      <PromoBanner data-id="element-4476" data-mp="2ms0q3pqf9vtv" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4477" data-mp="2mriqcj4jwzh7">
        <Header data-id="element-4478" data-mp="2rtq1x7lgydj0" />
        <main data-id="element-4479" data-mp="2rq2dgmuvshb5">
          <HeroSection h1Override={<>
                Dein Gehirn{' '}
                <span className="relative inline-block" data-id="element-4481" data-mp="71xuc2s8akhw">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-4482" data-mp="70czsd5wz1k1">
                    Lügt
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-4483" data-mp="c7t4ih7osppv" />
                </span>{' '}
                Dich an.
                <br data-id="element-4484" data-mp="3ezk65ddv055" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-4485" data-mp="3doiqc7eu4h7">
                  Unsere KI nicht.
                </span>
              </>} data-id="element-4480" data-mp="22uwb2ao1ejf" />
          <TrustSection data-id="element-4486" data-mp="3pkmsnbeinc05" />
          <FeaturesSection data-id="element-4487" data-mp="3pk3c9z4ikvo8" />
          <ForensicEvidenceSection data-id="element-4488" data-mp="3po0soczpj94f" />
          <GuaranteesSection data-id="element-4489" data-mp="3kltfjk355n0i" />
          <ToolsSection data-id="element-4490" data-mp="3kn3c24ucin51" />
          <ComparisonSection data-id="element-4491" data-mp="3koehe93fw2y9" />
          <PricingSection data-id="element-4492" data-mp="3glhsk0nb3alv" />
          <FAQSection data-id="element-4493" data-mp="3gmb2tblh4i8r" />
          <CTASection data-id="element-4494" data-mp="3gn2pty1097nf" />
        </main>
        <Footer data-id="element-4495" data-mp="1ivqbtt3bp3fb" />
      </div>
    </>;
}